module.exports = __webpack_public_path__ + "static/media/fiam.9c5de0d3.svg";